module.exports = "<div class=\"project-name-container\">\n    <div class=\"project-link\">\n        <a title=\"{{row.entity.modifiedName}}\" ui-sref=\"app.authorized.environments({id:row.entity.id,name: row.entity.name} )\"\n           ng-click=\"grid.appScope.openProject(row.entity.id)\"  >{{row.entity.modifiedName}}</a>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/projects/projects-list/templates/projectLink.tpl.html
// module id = 1823
// module chunks = 0